export default __webpack_public_path__ + "static/media/ID_6.1dd8c79d.png";